import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';

/* The page Header centres the title in a fixed-height bar, leaving about 18px under the title text, so the description pulls up to sit about 4px under it */
/* Its right padding keeps a long description clear of the last-checked stamp in HeaderSide */
export const HeaderDescription = styled.div`
  margin-top: -14px;
  margin-bottom: 16px;
  padding-right: 280px;
`;

export const TopGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(440px, 1fr) minmax(480px, 1.2fr);
  gap: 20px;

  @media (max-width: 1320px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

/* A platform's destinations panel heading, e.g. "Meta · 1 live", at the level under the Destinations heading */
export const DestinationsGroupTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.neutral100};
`;

export const EditForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0 16px;
  max-width: 960px;
`;

export const EditActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

/* Snap the tab indicator like the workflows page does */
export const TabsWrapper = styled.div`
  padding-top: 8px;

  .MuiTabs-indicator {
    transition: none;
  }
`;

/* The title row's right end: page actions centred on the title line, with the last-checked stamp hanging under them */
export const HeaderSide = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
`;

/* Out of flow, so the title bar centres the actions alone; it lands on the description's line */
export const HeaderStamp = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  white-space: nowrap;
`;

/* Sets the status pill a little further off the title than the Header's own gap */
export const TitleStatus = styled.span`
  margin-left: 7px;
`;

/* A detail tab's section: a heading at the Destinations level over unboxed content */
export const DetailsSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
`;

/* A full-width row under a run: its error, or its executed SQL */
export const SnapshotDetailCell = styled.td<{ error?: boolean }>`
  && {
    padding-top: 0;
    color: ${({ error }) => (error ? colors.red60 : colors.neutral90)};
  }

  pre {
    max-height: 420px;
    overflow: auto;
  }
`;
